import { z } from 'zod';

export const productTagSchema = z.object({
    product_tag_name: z.string({
        message : "Product Brand Name is required"
    }).nonempty({
         message : "Product Brand Name is required"
    }),
    description: z.string().nullable(),
});
